import { ReactElement } from 'react'

import ActiveOrInactiveImpl from 'modules/caminhao/domain/usecases/ActiveOrInactive'
import DeleteCaminhaoImpl from 'modules/caminhao/domain/usecases/DeleteCaminhao'
import FindCaminhaoByPlacaImpl from 'modules/caminhao/domain/usecases/FindCaminhaoByPlaca'

import CaminhaoRepository from '../../infra/repositories/CaminhaoRepository'
import List from '../../pages/List'

export const ListCaminhaoFactory = (): ReactElement => {
  const caminhaoRepository = new CaminhaoRepository()
  const findCaminhaoByPlacaImpl = new FindCaminhaoByPlacaImpl(
    caminhaoRepository,
  )
  const deleteCaminhao = new DeleteCaminhaoImpl(caminhaoRepository)
  const activeOrInactive = new ActiveOrInactiveImpl(caminhaoRepository)

  return (
    <List
      findCaminhaoByPlaca={findCaminhaoByPlacaImpl}
      deleteCaminhao={deleteCaminhao}
      activeOrInactive={activeOrInactive}
    />
  )
}
